

































import { Component, Vue } from "vue-property-decorator";
import Table from "@/components/blockbuster/Table.vue";
import Modal from "@/components/blockbuster/Modal.vue";
import Details from "@/components/blockbuster/Details.vue";
import metadata from "@/store/modules/metadata";
import MetadataModel from "@/models/MetadataModel";

@Component({
  components: {
    Table,
    Details,
    Modal,
  },
})
export default class Catalog extends Vue {
  selectedId: string | null = null;
  idToFlag: string | null = null;
  checkedRows: Array<string> = [];
  downloading = false;

  beforeUpdate(): void {
    const metadataToFlag = this.rows.find(
      (r: MetadataModel) => r.id === this.idToFlag
    );
    if (!!metadataToFlag && metadataToFlag.flagged) {
      this.idToFlag = null;
    }
  }

  get rows(): Array<MetadataModel> {
    return metadata.filtered;
  }

  get searchText(): string {
    return metadata.searchString;
  }

  set searchText(search: string) {
    metadata.updateSearch(search);
  }

  get selectedRow(): MetadataModel | undefined {
    return this.rows.find((e) => e.id === this.selectedId);
  }

  modalOpen(): boolean {
    return !!this.idToFlag;
  }

  cancelFlag(): void {
    this.idToFlag = null;
  }

  async confirmFlag(reason: string): Promise<void> {
    if (this.idToFlag !== null) {
      try {
        await metadata.flagMetadata({ id: this.idToFlag, reason });
      } catch (err) {
        this.$toasted.error("Flagging Video failed!", {
          position: "top-left",
          duration: 3000,
        });
      }
    }
  }

  handleSelectionChange(id: string): void {
    this.selectedId = id;
  }

  openModal(id: string): void {
    this.idToFlag = id;
  }

  toggleCheck(id: string): void {
    const index = this.checkedRows.indexOf(id);
    if (index > -1) {
      this.checkedRows.splice(index, 1);
    } else {
      this.checkedRows.push(id);
    }
  }

  async download(): Promise<void> {
    this.downloading = true;
    const filenames = this.checkedRows
      .map((id) => {
        const row = this.rows.find((row) => row.id === id);
        if (row) {
          return row.s3FileName;
        } else {
          return "";
        }
      })
      .filter((id) => id !== "");

    try {
      await metadata.downloadVideos(filenames);
      this.checkedRows = [];
    } catch (err) {
      this.$toasted.error("Download failed!", {
        position: "top-left",
        duration: 3000,
      });
    } finally {
      this.downloading = false;
    }
  }
}
